<div fxLayout="row" fxLayoutAlign="center" *ngIf="selectConfig !== null  && (rowData.file === undefined || rowData.file === null)">
  <mat-icon class="status-active"
            *ngIf="isSelected(rowData[selectConfig.identifierColumn]) else deselected"
            (click)="deselect(rowData[selectConfig.identifierColumn], $event)">
    check_circle_outline
  </mat-icon>
  <ng-template #deselected>
    <mat-icon  class="status-inactive"
              (click)="select(rowData[selectConfig.identifierColumn], $event)">
      radio_button_unchecked
    </mat-icon>
  </ng-template>
</div>
